import React, { useState } from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import FaqQuestion from '../Faq/FaqQuestion'
import CMSText from '../Global/CMSText'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'

type Tprops = {
  takeback: any
  t: any
}

const TakeBackFaq = ({ takeback, t }: Tprops) => {
  const classes = useTakeBackStyle()
  const faqTitle = takeback?.data?.faq_title
  const faqs = takeback?.data?.q_a
  const [isExpanded, setIsExpanded] = useState({ cat: null, question: null })

  const handleExpandClick = (question, cat) => {
    setIsExpanded((prev) =>
      prev.question === question && prev.cat === cat
        ? { cat: null, question: null }
        : { cat: cat, question: question }
    )
  }

  return (
    <section>
      <Typography
        variant="h3"
        component="h2"
        className={clsx('takeBack-faq__title', classes.faqTitle)}
      >
        <CMSText
          asText
          data={faqTitle}
          defaultText={t('texts:takeBack:faq_title')}
        />
      </Typography>
      {faqs && faqs.length !== 0 && (
        <ul className={clsx('takeBack-faq__list', classes.faqList)}>
          {faqs?.map((faq, index) => (
            <FaqQuestion
              key={index}
              question={faq.question}
              questionId={index}
              isExpanded={isExpanded.question === index}
              handleExpandClick={handleExpandClick}
              close_others={takeback?.data?.close_others_on_click}
              answer={faq.answer}
            />
          ))}
        </ul>
      )}
    </section>
  )
}

export default TakeBackFaq
